import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
    minHeight: '100vh',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    color: '#1F2937',
  },
  card: {
    marginBottom: theme.spacing(2),
    borderRadius: 12,
    boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
  },
  tableContainer: {
    borderRadius: 12,
    '& .MuiTable-root': {
      '& .MuiTableCell-head': {
        fontWeight: 700,
        backgroundColor: '#F9FAFB',
      },
    },
  },
  statusChip: {
    borderRadius: 8,
    fontWeight: 600,
    fontSize: 12,
    textTransform: 'capitalize' as const,
  },
  statusPending: {
    backgroundColor: '#FEF3C7',
    color: '#92400E',
  },
  statusRunning: {
    backgroundColor: '#DBEAFE',
    color: '#1E40AF',
  },
  statusSuccess: {
    backgroundColor: '#D1FAE5',
    color: '#065F46',
  },
  statusError: {
    backgroundColor: '#FEE2E2',
    color: '#991B1B',
  },
  statusCleaning: {
    backgroundColor: '#E0E7FF',
    color: '#3730A3',
  },
  statusCleaned: {
    backgroundColor: '#F3F4F6',
    color: '#6B7280',
  },
  logViewer: {
    backgroundColor: '#1F2937',
    color: '#E5E7EB',
    fontFamily: 'monospace',
    fontSize: 13,
    padding: theme.spacing(2),
    borderRadius: 8,
    maxHeight: 500,
    overflowY: 'auto' as const,
    whiteSpace: 'pre-wrap' as const,
    wordBreak: 'break-word' as const,
  },
  logInfo: { color: '#60A5FA' },
  logWarn: { color: '#FBBF24' },
  logError: { color: '#F87171' },
  logDebug: { color: '#9CA3AF' },
  speedSlider: {
    width: 300,
    marginLeft: theme.spacing(2),
  },
  backButton: {
    marginBottom: theme.spacing(2),
  },
  detailGrid: {
    marginBottom: theme.spacing(2),
  },
  actionButton: {
    textTransform: 'none' as const,
    borderRadius: 8,
    fontWeight: 600,
  },
}));
